// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50353cb6","239":"a0d68a7a","453":"fcf1c0df","455":"ae7c96ba"}[chunkId] + ".chunk.js";
};